import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DefaultColorPickerValues, EmailQuoteItem } from '@coin/shared/cms/util';
import { FormsModule } from '@angular/forms';
import { EmailSliderComponent } from '../../shared/email-slider/email-slider.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ColorPickerComponent } from '@coin/shared/core/feature-legacy-components';
import { V2TextInputComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-a-email-quote',
  templateUrl: './email-quote.component.html',
  styleUrls: ['./email-quote.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ColorPickerComponent, FormsModule, EmailSliderComponent, V2TextInputComponent, TranslatePipe]
})
export class EmailQuoteComponent implements OnInit {
  @Input() item: EmailQuoteItem = { content: { text: '' }, id: '' };
  @Input() contentEdit = false;
  @Input() showBackgroundPicker = false;

  ngOnInit(): void {
    this.item ??= {} as EmailQuoteItem;
    this.setDefaultColors();
  }

  private setDefaultColors(): void {
    this.item.backgroundColor = this.item.backgroundColor || DefaultColorPickerValues.backgroundColor;
    this.item.textColor = this.item.textColor || DefaultColorPickerValues.textColor;
  }
}
